var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.loadingScreen,"can-cancel":_vm.canCancel,"is-full-page":_vm.fullPage,"color":"#2dcecc","opacity":_vm.opacity},on:{"update:active":function($event){_vm.loadingScreen=$event}}}),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }